import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", stroke: "none", strokeWidth: 1, d: "M20 4c0-2.382-1.788-4-4-4H4a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V4zm-3.25 2.597L8.629 15.53a1 1 0 0 1-1.41 0l-3.923-3.9a1 1 0 0 1 1.41-1.418l3.218 3.199 7.447-8.02c.368-.348.898-.63 1.38-.081.323.366.323.796 0 1.288z", transform: "translate(2 2)" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
